import { useState, useEffect } from "react";
import orionAPI from "../config/orionAPI";

const useBlogPost = (id, { getAdjacent = false } = {}) => {
  const [state, setState] = useState({
    blogPost: null,
    prevPost: null,
    nextPost: null,
    loading: true,
  });

  useEffect(() => {
    const fetchBlogPost = async () => {
      setState((prev) => ({ ...prev, loading: true }));

      try {
        const { data } = await orionAPI.get(
          `/api/blog/posts/${id}${getAdjacent ? "?get_adjacent=true" : ""}`,
        );

        setState({
          blogPost: data.data,
          prevPost: getAdjacent ? data.data.prev || null : null,
          nextPost: getAdjacent ? data.data.next || null : null,
          loading: false,
        });
      } catch (error) {
        console.error(`Error fetching blog post with id ${id}:`, error);
        setState({
          blogPost: null,
          prevPost: null,
          nextPost: null,
          loading: false,
        });
      }
    };

    if (id) {
      fetchBlogPost();
    }
  }, [id, getAdjacent]);

  return state;
};

export default useBlogPost;
